<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <teleport to="#app">
    <oxd-dialog
      v-if="show"
      class="orangehrm-googlemap-dialog orangehrm-dialog-popup"
      @update:show="onCancel"
    >
      <div class="orangehrm-modal-header">
        <oxd-text type="card-title">{{ title }}</oxd-text>
      </div>
      <div class="orangehrm-text-center-align">
        <oxd-text type="card-body">
          {{ subtitle }}
        </oxd-text>
      </div>
      <GMapAutocomplete
        id="search-box-container"
        placeholder="搜尋地理位置"
        @place_changed="setPlace"
        style="font-size: medium"
      >
      </GMapAutocomplete>
      <div id="map" class="map">
        <GMapMap
          :center="center"
          :zoom="zoom"
          style="width: 100%; height: 65vh"
          @click="onMapClick"
          :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
          }"
        >
          <GMapMarker
            :position="center"
            :draggable="true"
            @dragend="onMarkerDragEnd"
          />
        </GMapMap>
      </div>
      <div class="orangehrm-modal-footer">
        <oxd-button
          label="取消"
          :display-type="cancelButtonType"
          class="orangehrm-button-margin"
          @click="onCancel"
        />
        <oxd-button
          :icon-name="icon"
          label="確定"
          :display-type="confirmButtonType"
          class="orangehrm-button-margin"
          @click="onConfirm"
        />
      </div>
    </oxd-dialog>
  </teleport>
</template>

<script>
import {GMapMap, GMapMarker} from '@fawmi/vue-google-maps';
import {OxdDialog} from '@ohrm/oxd';

export default {
  components: {
    'oxd-dialog': OxdDialog,
    GMapMap,
    GMapMarker,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    cancelLabel: {
      type: String,
      required: true,
    },
    confirmLabel: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
    confirmButtonType: {
      type: String,
      required: false,
      default: 'label-danger',
    },
    cancelButtonType: {
      type: String,
      required: false,
      default: 'text',
    },
    initialCenter: {
      type: Object,
      required: true,
    },
    initialZoom: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      show: false,
      reject: null,
      resolve: null,
      center: this.initialCenter,
      zoom: this.initialZoom,
      selectedLatLng: null,
    };
  },
  methods: {
    showDialog() {
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.show = true;
        this.$nextTick(() => {
          this.center = this.initialCenter;
        });
      });
    },
    onConfirm() {
      this.show = false;
      this.resolve && this.resolve(this.selectedLatLng);
    },
    onCancel() {
      this.show = false;
      this.resolve && this.resolve(null);
    },
    onMapClick(e) {
      this.selectedLatLng = {lat: e.latLng.lat(), lng: e.latLng.lng()};
      this.center = this.selectedLatLng;
    },
    onMarkerDragEnd(e) {
      this.selectedLatLng = {lat: e.latLng.lat(), lng: e.latLng.lng()};
      this.center = this.selectedLatLng;
    },

    setPlace(place) {
      this.selectedLatLng = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.center = this.selectedLatLng;
    },
  },
};
</script>

<style scoped>
.map {
  width: 100%;
}
#search-box-container {
  width: 100%;
}
</style>

<style src="./dialog.scss" lang="scss" scoped></style>
